import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy, ActivatedRouteSnapshot } from '@angular/router';

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const route = this.deepest(snapshot.root);
    if (route.data['skipTitle']) {
      this.title.setTitle(`Beamly Dashboard`);
      return;
    }
    
    const pageTitle =
      route.title
      ?? route.data['episode']?.title
      ?? route.data['post']?.title
      ?? route.data['page']?.title
      ?? route.data['podcast']?.title;

    if (pageTitle) this.title.setTitle(`${pageTitle} | Beamly`);
  }

  private deepest(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    while (route.firstChild) route = route.firstChild;
    return route;
  }
}
